"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _underscore = require("../utils/underscore");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _reactDom = require("react-dom");

var _Selectors = require("../constants/Selectors");

var _UIDialog = _interopRequireDefault(require("./UIDialog"));

var _UIDialogCloseButton = _interopRequireDefault(require("./UIDialogCloseButton"));

var _UIOverlay = _interopRequireDefault(require("../overlay/UIOverlay"));

var _Dom = require("../utils/Dom");

var _decorators = require("../utils/propTypes/decorators");

var _DialogConstants = require("./DialogConstants");

var _ModalContext = require("../context/ModalContext");

var getContext = function getContext(use, headerCallback) {
  return {
    use: use,
    headerCallback: headerCallback
  };
};

var hasPingedNewRelic = false; // Report "special" modals that lack a proper header (#6712)

var reportDeprecatedModalMarkup = function reportDeprecatedModalMarkup(el) {
  if (!el) return;
  if (el.querySelector('.private-modal__header + .private-modal__body')) return;
  ['success', 'danger', 'info'].forEach(function (variant) {
    for (var headingLevel = 1; headingLevel <= 6; headingLevel++) {
      if (el.querySelector(".private-modal--" + variant + " .private-modal__body h" + headingLevel)) {
        if (process.env.NODE_ENV !== 'production') {
          _devLogger.default.warn({
            message: "Modals with `use=\"" + variant + "\"` should wrap their heading in a `UIDialogHeader`.",
            key: 'legacy-modal-markup'
          });
        }

        if (window.newrelic && !hasPingedNewRelic) {
          window.newrelic.addPageAction('legacy-modal', {
            variant: variant,
            headingLevel: headingLevel
          });
          hasPingedNewRelic = true;
        }
      }
    }
  });
};

var UIModalDialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIModalDialog, _React$Component);

  function UIModalDialog(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIModalDialog);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIModalDialog).call(this, props));

    _this.handleOpenComplete = function () {
      _this.setState({
        openComplete: true
      });

      _this.startMutationObserver();

      _this.captureFocus();
    };

    _this.handleCloseStart = function () {
      if (!_this._isMounted) return;

      _this.stopMutationObserver();
    };

    _this.startMutationObserver = function () {
      if (_this._observer) return;
      var dialog = (0, _reactDom.findDOMNode)(_this._ref);
      if (!dialog) return; // The focus should always be inside of the modal. We may need to recapture
      // it after an update because the focused element may have been unmounted.

      _this._observer = new MutationObserver(_this.captureFocus);

      _this._observer.observe(dialog, {
        attributes: true,
        childList: true,
        subtree: true
      }); // Disable the mutation observer during blur, as the value of
      // document.activeElement in that phase is misleading.


      addEventListener('blur', _this.stopMutationObserver, {
        capture: true
      });
      addEventListener('focus', _this.startMutationObserver, {
        capture: true
      });
    };

    _this.stopMutationObserver = function () {
      if (_this._observer) {
        _this._observer.disconnect();

        _this._observer = null;
      }

      removeEventListener('blur', _this.stopMutationObserver, {
        capture: true
      });
      removeEventListener('focus', _this.startMutationObserver, {
        capture: true
      });
    };

    _this.captureFocus = function () {
      // If the focus is currently within the page (or null/<body>), focus on this
      // dialog so that tabbing works. We *don't* want to capture focus if the
      // element is in a non-page element, e.g. a popover or other modal.
      var dialog = (0, _reactDom.findDOMNode)(_this._ref);
      if (!dialog) return;
      var activeElement = document.activeElement;
      var dialogContainsActiveElement = dialog.contains(activeElement);
      var shouldCapture = false;

      if (!activeElement || activeElement === document.body) {
        shouldCapture = true;
      } else if (!dialogContainsActiveElement) {
        // A few weird apps have multiple .page elements...
        var pages = document.querySelectorAll('body > .page');

        for (var i = 0; i < pages.length; i++) {
          if (pages[i].contains(activeElement)) {
            shouldCapture = true;
            break;
          }
        }
      } // Also, we also want to move focus to the dialog if the focus has somehow
      // wound up on a non-focusable element *within* the dialog.


      if (dialogContainsActiveElement && !(0, _Dom.matches)(activeElement, _Selectors.FOCUSABLE)) {
        shouldCapture = true;
      }

      if (shouldCapture) {
        dialog.focus();
      }
    };

    _this.refCallback = function (ref) {
      _this._ref = ref;
    };

    _this.handleKeyDown = function (evt) {
      var onEsc = _this.props.onEsc;
      var dialog = (0, _reactDom.findDOMNode)(_this._ref);
      if (!dialog) return;

      if (evt.key === 'Tab') {
        // Based on https://www.w3.org/TR/wai-aria-practices/#trap_focus_div
        var activeElement = document.activeElement;
        var allFocusableElements = dialog.querySelectorAll(_Selectors.FOCUSABLE);
        var firstFocusableElement = (0, _underscore.first)(allFocusableElements);
        var lastFocusableElement = (0, _underscore.last)(allFocusableElements);

        if (evt.shiftKey) {
          // Shift+Tab: If focus is on first element, cycle to last element
          if (activeElement === firstFocusableElement || activeElement === dialog) {
            evt.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Unmodified Tab: If focus is on last element, cycle to first element
          if (activeElement === lastFocusableElement || activeElement === dialog) {
            evt.preventDefault();
            firstFocusableElement.focus();
          }
        }
      } else if (evt.key === 'Escape') {
        if (typeof onEsc === 'function') {
          onEsc(evt);
        } else {
          var closeButton = dialog.querySelector('[data-action=close]');
          if (closeButton) closeButton.click();
        }
      }
    };

    _this.headerCallback = function (headerOverflow) {
      if (headerOverflow !== _this.state.headerOverflow) {
        _this.setState({
          headerOverflow: headerOverflow
        });
      }
    };

    _this.state = {
      headerOverflow: 0,
      openComplete: !props._openCompleteRelay
    };
    _this._getContext = (0, _memoizeOne.default)(getContext);
    if (props._openCompleteRelay) props._openCompleteRelay.subscribe(_this.handleOpenComplete);
    if (props._closeStartRelay) props._closeStartRelay.subscribe(_this.handleCloseStart);
    return _this;
  }

  (0, _createClass2.default)(UIModalDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      reportDeprecatedModalMarkup((0, _reactDom.findDOMNode)(this._ref));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      reportDeprecatedModalMarkup((0, _reactDom.findDOMNode)(this._ref));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.stopMutationObserver();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          centered = _this$props.centered,
          children = _this$props.children,
          className = _this$props.className,
          contextual = _this$props.contextual,
          dialogClassName = _this$props.dialogClassName,
          _dialogWidth = _this$props._dialogWidth,
          __onEsc = _this$props.onEsc,
          role = _this$props.role,
          size = _this$props.size,
          use = _this$props.use,
          _use = _this$props._use,
          __closeStartRelay = _this$props._closeStartRelay,
          __openCompleteRelay = _this$props._openCompleteRelay,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["centered", "children", "className", "contextual", "dialogClassName", "_dialogWidth", "onEsc", "role", "size", "use", "_use", "_closeStartRelay", "_openCompleteRelay"]);
      var openComplete = this.state.openComplete;
      var computedUse = _use || use; // If one of the children is <UIDialogCloseButton detached>, render it in
      // the overlay instead of the dialog.

      var closeButton = null;

      var dialogChildren = _react.default.Children.map(children, function (child) {
        if (child === null) {
          return null;
        } else if (child.type === _UIDialogCloseButton.default && child.props.detached) {
          closeButton = child;
          return null;
        }

        return child;
      });

      var centerContent = ['fullscreen', 'sidebar', 'lightbox'].indexOf(computedUse) === -1;
      return _react.default.createElement(_ModalContext.ModalContextProvider, {
        value: this._getContext(use, this.headerCallback)
      }, _react.default.createElement(_UIOverlay.default, (0, _extends2.default)({}, rest, {
        centerContent: centerContent,
        className: (0, _classnames.default)(className, 'private-modal-dialog--overlay'),
        contextual: contextual,
        "data-component-name": "UIModalDialog",
        "data-open-complete": openComplete,
        onKeyDown: this.handleKeyDown,
        ref: this.refCallback,
        tabIndex: -1
      }), _react.default.createElement(_UIDialog.default, {
        _dialogWidth: _dialogWidth,
        centered: centered,
        className: dialogClassName,
        headerOverflow: this.state.headerOverflow,
        role: role !== undefined ? role : 'dialog',
        size: size,
        use: computedUse
      }, dialogChildren), closeButton));
    }
  }]);
  return UIModalDialog;
}(_react.default.Component);

UIModalDialog.propTypes = {
  centered: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  contextual: (0, _decorators.hidden)(_propTypes.default.bool),
  _dialogWidth: _UIDialog.default.propTypes._dialogWidth,
  dialogClassName: _propTypes.default.string,
  onEsc: _propTypes.default.func,
  size: _propTypes.default.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
  use: _propTypes.default.oneOf(Object.keys(_DialogConstants.DIALOG_USE_CLASSES)),
  _use: _propTypes.default.oneOf(['sidebar']),
  width: _UIOverlay.default.propTypes.width,
  _openCompleteRelay: _propTypes.default.object,
  _closeStartRelay: _propTypes.default.object
};
UIModalDialog.contextTypes = {
  sandboxed: _propTypes.default.bool
};
UIModalDialog.defaultProps = {
  centered: false,
  contextual: false,
  use: 'default',
  size: 'auto',
  width: 450
};
UIModalDialog.displayName = 'UIModalDialog';
var _default = UIModalDialog;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dialog/UIModalDialog.js
// module id = 406
// module chunks = 5 6